<template>
    <div v-if="fetched">
        <!-- Form Example -->

        <d-list-group flush>
            <d-list-group-item class="p-3">
                <d-form>
                    <d-form-row>
                        <d-col md="6">
                            <fieldset class="form-group">
                                <label>Typ poręczyciela</label>
                                <d-select name="type"
                                          v-model="guarantor.type"
                                          @input="lar_errors.clear('type')"
                                          :class="{'is-invalid' : lar_errors.has('type')}"
                                          placeholder="">
                                    <option value="">--Wybierz typ</option>
                                    <option value="person">Osoba</option>
                                    <option value="corporation">Spółka</option>
                                </d-select>
                                <div class="invalid-feedback" v-text="lar_errors.get('type')"></div>
                            </fieldset>
                        </d-col>
                    </d-form-row>
                    <d-form-row v-if="guarantor.type === 'person'">
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.name" name="name" label="Imię" placeholder="Imię"></ss-input>
                        </d-col>
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.surname" name="surname" label="Nazwisko" placeholder="Nazwisko"></ss-input>
                        </d-col>
                    </d-form-row>
                    <d-form-row v-if="guarantor.type === 'corporation'">
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.company_name" name="company_name" label="Nazwa spółki" placeholder="Nazwa spółki"></ss-input>
                        </d-col>
                        <d-col md="6" class="form-group">
                            <label for="nip">NIP</label>
                            <d-input
                                    id="nip"
                                    name="nip"
                                    @input="lar_errors.clear('nip')"
                                    :class="{'is-invalid' : lar_errors.has('nip')}"
                                    v-model="guarantor.nip"
                                    v-mask="'###########'"
                            />
                        </d-col>
                    </d-form-row>
                    <d-form-row v-if="guarantor.type === 'corporation'">
                        <d-col md="6" class="form-group">
                            <label for="regon">Regon</label>
                            <d-input
                                    id="regon"
                                    name="regon"
                                    v-model="guarantor.regon"
                                    v-mask="'#########'"
                                    @input="lar_errors.clear('regon')"
                                    :class="{'is-invalid' : lar_errors.has('regon')}"
                            />
                        </d-col>
                        <d-col md="6" class="form-group">
                            <label for="krs">KRS</label>
                            <d-input
                                    id="krs"
                                    name="krs"
                                    v-model="guarantor.krs"
                                    placeholder="KRS"
                                    @input="lar_errors.clear('krs')"
                                    :class="{'is-invalid' : lar_errors.has('krs')}"
                            />
                        </d-col>
                    </d-form-row>
                    <d-form-row>
                        <d-col md="6" class="form-group">
                            <label for="phone">Telefon</label>
                            <d-input
                                id="phone"
                                type="text"
                                name="phone"
                                v-model="guarantor.phone"
                                @input="lar_errors.clear('phone')"
                                :class="{'is-invalid' : lar_errors.has('phone')}"
                                placeholder="Nr telefonu" />
                        </d-col>
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.email" name="email" label="Adres e-mail" placeholder="Adres e-mail"></ss-input>
                        </d-col>
                    </d-form-row>
                    <d-form-row>
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.street" name="street" label="Ulica" placeholder="Ulica"></ss-input>
                        </d-col>
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.house_number" name="house_number" label="Nr budynku" placeholder="Nr budynku"></ss-input>
                        </d-col>
                    </d-form-row>
                    <d-form-row>
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.flat_number" name="flat_number" label="Nr lokalu" placeholder="Nr lokalu"></ss-input>
                        </d-col>
                    </d-form-row>
                    <d-form-row>
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.postcode" name="postcode" label="Kod pocztowy" placeholder="00-000" mask="##-###"></ss-input>
                        </d-col>
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.city" name="city" label="Miasto" placeholder="Miasto"></ss-input>
                        </d-col>
                    </d-form-row>

                    <d-form-row v-if="guarantor.type === 'person'">
                        <d-col md="6">
                            <div class="mb-4">
                                <label>Typ dokumentu tożsamości</label>
                                <div v-for="idDocType in idDocumentsTypes">
                                    <d-form-radio
                                        name="id_card_type"
                                        v-model="guarantor.id_card_type"
                                        :value="idDocType.value"
                                        default>
                                        {{ idDocType.label }}
                                    </d-form-radio>
                                </div>
                            </div>
                        </d-col>
                        <d-col md="6" class="form-group">
                            <label for="id_card">Nr dokumentu tożsamości</label>
                            <d-input
                                id="id_card"
                                name="id_card"
                                v-model="guarantor.id_card"
                                v-mask="getSelectedDocTypeMask(guarantor.id_card_type)"
                                placeholder="Nr dokumentu tożsamości"
                                @input="lar_errors.clear('id_card')"
                                :class="{'is-invalid' : lar_errors.has('id_card')}"
                                />
                        </d-col>
                        <d-col md="6" class="form-group">
                            <label for="pesel">Nr pesel</label>
                            <d-input
                                id="pesel"
                                name="pesel"
                                v-model="guarantor.pesel"
                                v-mask="'###########'"
                                @input="lar_errors.clear('pesel')"
                                :class="{'is-invalid' : lar_errors.has('pesel')}"
                                />
                        </d-col>
                    </d-form-row>

                    <d-form-row>
                        <d-col md="6" class="form-group">
                            <label>Maksymalna kwota poręczenia</label>
                            <ss-price-input name="guarantee_amount"
                                            v-model="guarantor.guarantee_amount"
                                            @input="lar_errors.clear('guarantee_amount')"
                                            :class="{'is-invalid' : lar_errors.has('guarantee_amount')}"
                                            placeholder=""/>
                            <div class="invalid-feedback" v-text="lar_errors.get('guarantee_amount')"></div>
                        </d-col>
                        <d-col md="6" class="form-group">
                            <label>Data ważności poręczenia</label>
                            <ss-date type="text"
                                     name="guarantee_date"
                                     v-model="guarantor.guarantee_date"
                                     @click="lar_errors.clear('guarantee_date')"
                                     :class="{'is-invalid' : lar_errors.has('guarantee_date')}"
                                     placeholder=""/>
                            <div class="invalid-feedback" v-text="lar_errors.get('guarantee_date')"></div>
                        </d-col>
                    </d-form-row>
                    <d-form-row v-if="guarantor.type === 'person'">
                        <d-col md="6" class="form-group">
                            <label>Stan cywilny</label>
                            <d-select
                                type="text"
                                name="marital_status"
                                v-model="guarantor.marital_status"
                                @input="lar_errors.clear('marital_status')"
                                :class="{'is-invalid' : lar_errors.has('marital_status')}"
                                placeholder="">
                                <option :value="null">--Wybierz stan cywilny</option>
                                <option
                                    v-for="status in clientUtils._marital_statuses"
                                    :key="status.id"
                                    :value="status.value">
                                    {{ status.name }}
                                </option>
                            </d-select>
                            <div class="invalid-feedback" v-text="lar_errors.get('marital_status')"></div>
                        </d-col>
                        <d-col
                            v-if="guarantor.marital_status === 1"
                            md="6" class="form-group">
                            <label>Rozdzielność majątkowa</label>
                            <d-select
                                type="text"
                                name="property_separation"
                                v-model="guarantor.property_separation"
                                @input="lar_errors.clear('property_separation')"
                                :class="{'is-invalid' : lar_errors.has('property_separation')}"
                                placeholder="">
                                <option :value="null">--Wybierz opcję</option>
                                <option
                                    v-for="properties in clientUtils._property_separations"
                                    :key="properties.id"
                                    :value="properties.value">
                                    {{ properties.name }}
                                </option>
                            </d-select>
                            <div class="invalid-feedback" v-text="lar_errors.get('property_separation')"></div>
                        </d-col>
                        <d-col
                            v-else-if="guarantor.marital_status === 2"
                            md="6" class="form-group">
                            <ss-textarea
                                name="marital_status_other"
                                v-model="guarantor.marital_status_other"
                                label="Opis stanu cywilnego"
                                placeholder="Opis..."
                                :rows="2"
                                :class="{'is-invalid' : lar_errors.has('marital_status_other')}">
                            </ss-textarea>
                            <div class="invalid-feedback" v-text="lar_errors.get('marital_status_other')"></div>
                        </d-col>
                    </d-form-row>
                    <div class="form-group">
                        <ss-textarea v-model="guarantor.marital_status_text" name="marital_status_text" :label="guarantor.type === 'corporation' ? 'Oświadczenie wyrażenia zgody na poręczenie' : 'Oświadczenie o statusie cywilnym'" placeholder="Treść..."></ss-textarea>
                    </div>
                    <d-checkbox
                        :value="'1'"
                        :unchecked-value="'0'"
                        toggle
                        v-model="guarantor.represented_by_proxy">
                        jest reprezentowany przez pełnomocnika
                    </d-checkbox>
                </d-form>
            </d-list-group-item>
        </d-list-group>
        <d-card-header class="border-bottom border-top" v-if="guarantor.represented_by_proxy.toString() === '1'">
            <h6 class="m-0">Dane pełnomocnika</h6>
        </d-card-header>
        <d-list-group flush v-if="guarantor.represented_by_proxy.toString() === '1'">
            <d-list-group-item class="p-3">
                <d-form>
                    <d-form-row>
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.proxy_name" name="proxy_name" label="Imię" placeholder="Imię"></ss-input>
                        </d-col>
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.proxy_surname" name="proxy_surname" label="Nazwisko" placeholder="Nazwisko"></ss-input>
                        </d-col>
                    </d-form-row>
                    <d-form-row>
                        <d-col md="6" class="form-group">
                            <label for="proxy_phone">Telefon</label>
                            <d-input
                                id="proxy_phone"
                                type="text"
                                name="phone"
                                v-model="guarantor.proxy_phone"
                                placeholder="Nr telefonu"
                                @input="lar_errors.clear('proxy_phone')"
                                :class="{'is-invalid' : lar_errors.has('proxy_phone')}" />
                        </d-col>
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.proxy_email" name="proxy_email" label="Adres e-mail" placeholder="Adres e-mail"></ss-input>
                        </d-col>
                    </d-form-row>
                    <d-form-row>
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.proxy_street" name="proxy_street" label="Ulica" placeholder="Ulica"></ss-input>
                        </d-col>
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.proxy_house_number" name="proxy_house_number" label="Nr budynku" placeholder="Nr budynku"></ss-input>
                        </d-col>
                    </d-form-row>
                    <d-form-row>
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.proxy_flat_number" name="proxy_flat_number" label="Nr lokalu" placeholder="Nr lokalu"></ss-input>
                        </d-col>
                    </d-form-row>
                    <d-form-row>
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.proxy_postcode" name="proxy_postcode" label="Kod pocztowy" placeholder="00-000" mask="##-###"></ss-input>
                        </d-col>
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.proxy_city" name="proxy_city" label="Miasto" placeholder="Miasto"></ss-input>
                        </d-col>
                    </d-form-row>
                    <d-form-row>
                        <d-col md="6">
                            <div class="mb-4">
                                <label>Typ dokumentu tożsamości</label>
                                <div v-for="idDocType in idDocumentsTypes">
                                    <d-form-radio
                                        name="proxy_id_card_type"
                                        v-model="guarantor.proxy_id_card_type"
                                        :value="idDocType.value"
                                        default>
                                        {{ idDocType.label }}
                                    </d-form-radio>
                                </div>
                            </div>
                        </d-col>
                        <d-col md="6" class="form-group">
                            <label for="proxy_id_card">Nr dokumentu tożsamości</label>
                            <d-input
                                id="proxy_id_card"
                                name="proxy_id_card"
                                @input="lar_errors.clear('proxy_id_card')"
                                :class="{'is-invalid' : lar_errors.has('proxy_id_card')}"
                                v-model="guarantor.proxy_id_card"
                                v-mask="getSelectedDocTypeMask(guarantor.proxy_id_card_type)"
                                placeholder="Nr dokumentu tożsamości"
                                />
                        </d-col>
                        <d-col md="6" class="form-group">
                            <ss-input v-model="guarantor.proxy_pesel" name="proxy_pesel" label="Nr pesel" placeholder="Nr pesel"></ss-input>
                        </d-col>
                    </d-form-row>
                    <d-form-row>
                        <d-col md="6" class="form-group">
                            <label>Stan cywilny</label>
                            <d-select
                                type="text"
                                name="proxy_marital_status"
                                v-model="guarantor.proxy_marital_status"
                                @input="lar_errors.clear('proxy_marital_status')"
                                :class="{'is-invalid' : lar_errors.has('proxy_marital_status')}"
                                placeholder="">
                                <option :value="null">--Wybierz stan cywilny</option>
                                <option
                                    v-for="status in clientUtils._marital_statuses"
                                    :key="status.id"
                                    :value="status.value">
                                    {{ status.name }}
                                </option>
                            </d-select>
                            <div class="invalid-feedback" v-text="lar_errors.get('proxy_marital_status')"></div>
                        </d-col>
                        <d-col
                            v-if="guarantor.proxy_marital_status === 1"
                            md="6" class="form-group">
                            <label>Rozdzielność majątkowa</label>
                            <d-select
                                type="text"
                                name="proxy_property_separation"
                                v-model="guarantor.proxy_property_separation"
                                @input="lar_errors.clear('proxy_property_separation')"
                                :class="{'is-invalid' : lar_errors.has('proxy_property_separation')}"
                                placeholder="">
                                <option :value="null">--Wybierz opcję</option>
                                <option
                                    v-for="properties in clientUtils._property_separations"
                                    :key="properties.id"
                                    :value="properties.value">
                                    {{ properties.name }}
                                </option>
                            </d-select>
                            <div class="invalid-feedback" v-text="lar_errors.get('proxy_property_separation')"></div>
                        </d-col>
                        <d-col
                            v-else-if="guarantor.proxy_marital_status === 2"
                            md="6" class="form-group">
                            <ss-textarea
                                name="proxy_marital_status_other"
                                v-model="guarantor.proxy_marital_status_other"
                                label="Opis stanu cywilnego"
                                placeholder="Opis..."
                                :rows="2"
                                :class="{'is-invalid' : lar_errors.has('proxy_marital_status_other')}">
                            </ss-textarea>
                            <div class="invalid-feedback" v-text="lar_errors.get('proxy_marital_status_other')"></div>
                        </d-col>
                    </d-form-row>
                </d-form>
            </d-list-group-item>
        </d-list-group>
    </div>
</template>

<script>
    import LarErrors from '../../helpers/Errors';
    import SsPriceInput from '../common/SsPriceInput';
    import SsDate from '../common/SsDate';
    import clientUtils from '../../utils/client';
    import IdDocumentsTypes from '@/data/id-documents-types.js';

    export default {
        name: "Guarantor",
        components: {
            LarErrors,
            SsPriceInput,
            SsDate,
            clientUtils
        },
        props: {
            props: {
                type: Object,
                default: {}
            }
        },
        computed: {
            idDocumentsTypes () {
                return IdDocumentsTypes;
            }
        },
        data(){
            return{
                fetched: false,
                lar_errors: LarErrors,
                submitting: false,
                clientUtils: clientUtils,
                guarantor: {
                    client_id:              '',
                    id:                     '',
                    name:                   '',
                    surname:                '',
                    type:                   null,
                    street:                 '',
                    house_number:           '',
                    flat_number:            '',
                    postcode:               '',
                    city:                   '',
                    id_card:                '',
                    id_card_type:          'id',
                    pesel:                  '',
                    phone:                  '',
                    email:                  '',
                    nip:                    '',
                    company_name:          '',
                    represented_by_proxy:   '0',
                    proxy_name:             '',
                    proxy_surname:          '',
                    proxy_street:           '',
                    proxy_flat_number:      '',
                    proxy_house_number:     '',
                    proxy_postcode:         '',
                    proxy_city:             '',
                    proxy_id_card:          '',
                    proxy_id_card_type:     'id',
                    proxy_pesel:            '',
                    proxy_phone:            '',
                    proxy_email:            '',
                    proxy_marital_status: null,
                    proxy_marital_status_other: '',
                    marital_status:         null,
                    marital_status_other:   '',
                    marital_status_text:    '',
                    guarantee_amount:       '0',
                    guarantee_date:         '',
                    regon:                  '',
                    krs:                    '',
                    property_separation:    null
                },
            }
        },
        mounted(){
            if (this.props) {
                this.guarantor = this.props;
                this.formatFields();
            }

            this.fetched = true;
        },
        watch: {
            props: {
                handler: function(to) {
                    this.guarantor = to;
                    this.formatFields();
                },
                deep: true
            }
        },
        methods: {
            formatFields () {
                if (this.guarantor && ('represented_by_proxy' in this.guarantor)) {
                    if (typeof this.guarantor.represented_by_proxy === 'number') {
                        this.guarantor.represented_by_proxy = this.guarantor.represented_by_proxy.toString();
                    }

                    if (this.guarantor.represented_by_proxy === '') {
                        this.guarantor.represented_by_proxy = '0';
                    }
                }
            },
            getSelectedDocTypeMask (docType) {
                let foundType = this.idDocumentsTypes.find(item => item.value === docType);
                if (foundType) {
                    return foundType.mask;
                }

                return 'AAA######';
            },
        }
    }
</script>
